/**
 * CMS variant labels often contain "." (e.g. pearl sizes). next-intl treats "."
 * as a nested key path, so lookups must use a flat key — we mirror messages/*.json
 * by replacing dots with underscores. Also tries a common "10m" → "10mm" alias.
 */
export type ProductDetailsVariantTranslator = {
  (key: string): string;
  has: (key: string) => boolean;
};

export function productVariantDetailsMessageKey(cmsVariant: string): string {
  return cmsVariant.replace(/\./g, "_");
}

function withPearlMmAliasKey(key: string): string {
  return key.replace(/(\d)-10m(?=\s|$)/, "$1-10mm");
}

export function translateProductVariantLabel(
  t: ProductDetailsVariantTranslator,
  cmsVariant: string,
): string {
  const primary = productVariantDetailsMessageKey(cmsVariant);
  if (t.has(primary)) return t(primary);
  const mmAlias = withPearlMmAliasKey(primary);
  if (mmAlias !== primary && t.has(mmAlias)) return t(mmAlias);
  return cmsVariant;
}
